// Naming format: [component]_[description]_[element-type]
const SUMMARY_EDIT_FEE_BUTTON = 'summary-edit-fee-button'
const SUMMARY_EDIT_FEE_MODAL = 'summary-edit-fee-modal'
const SUMMARY_EDIT_FEE_FORM_PRICE_INPUT = 'summary-edit-fee-form-price-input'

export default {
  SUMMARY_EDIT_FEE_BUTTON,
  SUMMARY_EDIT_FEE_MODAL,
  SUMMARY_EDIT_FEE_FORM_PRICE_INPUT,
}
